import {
  SOCIAL_SHARING_SERVICES,
  SOCIAL_SHARING_SERVICES_BI_MAP,
} from '@wix/music-shared/dist/src/social-sharing/social-sharing-types';
import {ENTER_KEY, SPACE_KEY, TAB_KEY} from '@wix/music-shared/dist/src/utils/keyboard/key-codes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {AnyToDo} from '../../../typings/todo';
import ShareIconSVG from '../../assets/svg-icons/ShareIcon.inline.svg';
import BloggerIconSvg from '../../assets/svg-icons/social-share-icons/Blogger.inline.svg';
import FacebookIconSvg from '../../assets/svg-icons/social-share-icons/Facebook.inline.svg';
import TumblrIconSvg from '../../assets/svg-icons/social-share-icons/Tumblr.inline.svg';
import TwitterIconSvg from '../../assets/svg-icons/social-share-icons/Twitter.inline.svg';
import {withTrackFont} from '../../containers/DataContainer/siteSettings/withTrackFont';
import {BI_SCHEMA} from '../../services/biLogger/biEvents';
import {BiLogger} from '../../services/biLogger/biLogger';
import {withoutSize} from '../../services/env/siteSettings/fonts/fonts';
import {shareTrack} from '../../services/socialSharing';
import {withBiLogger} from '../BiProvider/withBiLogger';
import {SVGIcon} from '../ui/SVGIcon/SVGIcon';
import {ShareButton} from './ShareButton/ShareButton';
import styles from './ShareButtons.scss';

class ShareButtonsComponent extends React.Component<AnyToDo, AnyToDo> {
  static propTypes = {
    biLogger: PropTypes.object,
    className: PropTypes.string,
    album: PropTypes.object,
    track: PropTypes.object,
    siteInfo: PropTypes.object,
    isDisabled: PropTypes.bool,
    withText: PropTypes.bool,

    trackFont: PropTypes.object,
  };
  static defaultProps = {
    isDisabled: false,
    withText: false,
  };

  constructor(props) {
    super(props);

    this.state = {isActive: false};

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleShareButtonKeyDown = this.handleShareButtonKeyDown.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleShareServiceButtonKeyDown = this.handleShareServiceButtonKeyDown.bind(this);
    this.handleFirstServiceButtonKeyDown = this.handleFirstServiceButtonKeyDown.bind(this);
    this.handleLastServiceButtonKeyDown = this.handleLastServiceButtonKeyDown.bind(this);
  }

  get socialServiceButtonTabIndex() {
    return this.state.isActive ? 0 : -1;
  }

  setActive() {
    if (this.props.isDisabled) {
      return;
    }

    this.setState({isActive: true});
  }

  setInactive() {
    this.setState({isActive: false});
  }
  handleMouseEnter() {
    this.setActive();
  }
  handleShareButtonKeyDown(event) {
    const {keyCode} = event;

    if (keyCode === ENTER_KEY || keyCode === SPACE_KEY) {
      this.setActive();
    }
  }
  handleMouseLeave() {
    this.setInactive();
  }
  handleTouchStart() {
    this.setActive();
  }
  handleShareServiceButtonKeyDown({keyCode}) {
    if (keyCode === ENTER_KEY || keyCode === SPACE_KEY) {
      this.setInactive();
    }
  }
  handleFirstServiceButtonKeyDown(event) {
    const {keyCode, shiftKey} = event;

    if (keyCode === TAB_KEY && shiftKey) {
      this.setInactive();
      return;
    }

    this.handleShareButtonKeyDown(event);
  }
  handleLastServiceButtonKeyDown(event) {
    const {keyCode, shiftKey} = event;

    if (keyCode === TAB_KEY && !shiftKey) {
      this.setInactive();
      return;
    }

    this.handleShareButtonKeyDown(event);
  }

  shareTrack(social: SOCIAL_SHARING_SERVICES) {
    const {album, track, siteInfo} = this.props;
    const biLogger: BiLogger = this.props.biLogger;
    biLogger.log(BI_SCHEMA.player.track.shared, {
      socialNetwork: SOCIAL_SHARING_SERVICES_BI_MAP[social],
      trackID: String(track.id),
      trackIdxInAlbum: album.tracks.indexOf(track),
    });
    shareTrack(social, album, track, siteInfo);
  }

  render() {
    const {t, className, isDisabled, withText, trackFont} = this.props;
    const {isActive} = this.state;
    const socialServiceButtonTabIndex = this.socialServiceButtonTabIndex;

    return (
      <div className={classNames(styles.container, className)} data-hook="share-buttons-container">
        <div
          className={classNames(styles.shareButtonsWrapper, {[styles.active]: isActive})}
          onMouseLeave={this.handleMouseLeave}
          data-hook="share-buttons-wrapper"
        >
          <div
            className={classNames(styles.shareButtonWrapper, {[styles.disabled]: isDisabled})}
            onMouseEnter={this.handleMouseEnter}
            onTouchStart={this.handleTouchStart}
            onKeyDown={this.handleShareButtonKeyDown}
            data-hook="share-button-wrapper"
          >
            <button
              className={classNames(styles.shareButton)}
              aria-hidden={isActive}
              aria-label={t('mgw.aria.shareButtons.shareButton')}
              data-hook="share-button"
            >
              <SVGIcon Svg={ShareIconSVG} className={styles.shareIcon} dataHook="share-button-icon" />
            </button>

            {withText ? (
              <span className={styles.shareButtonText} style={withoutSize(trackFont)} data-hook="share-button-message">
                {t('mgw.shareTrack')}
              </span>
            ) : null}
          </div>

          <div className={styles.socialButtonsContainer} data-hook="social-buttons-container">
            <ShareButton
              className={styles.shareButtonService}
              iconSvg={FacebookIconSvg}
              accName={t('mgw.aria.shareButtons.shareButton.facebook')}
              onClick={() => this.shareTrack(SOCIAL_SHARING_SERVICES.FACEBOOK)}
              onKeyDown={this.handleFirstServiceButtonKeyDown}
              tabIndex={socialServiceButtonTabIndex}
              dataHook="facebook-social-share-button"
            />
            <ShareButton
              className={styles.shareButtonService}
              iconSvg={TwitterIconSvg}
              accName={t('mgw.aria.shareButtons.shareButton.twitter')}
              onClick={() => this.shareTrack(SOCIAL_SHARING_SERVICES.TWITTER)}
              onKeyDown={this.handleShareServiceButtonKeyDown}
              tabIndex={socialServiceButtonTabIndex}
              dataHook="twitter-social-share-button"
            />
            <ShareButton
              className={styles.shareButtonService}
              iconSvg={TumblrIconSvg}
              accName={t('mgw.aria.shareButtons.shareButton.tumblr')}
              onClick={() => this.shareTrack(SOCIAL_SHARING_SERVICES.TUMBLR)}
              onKeyDown={this.handleShareServiceButtonKeyDown}
              tabIndex={socialServiceButtonTabIndex}
              dataHook="tumblr-social-share-button"
            />
            <ShareButton
              className={styles.shareButtonService}
              iconSvg={BloggerIconSvg}
              accName={t('mgw.aria.shareButtons.shareButton.blogger')}
              onClick={() => this.shareTrack(SOCIAL_SHARING_SERVICES.BLOGGER)}
              onKeyDown={this.handleLastServiceButtonKeyDown}
              tabIndex={socialServiceButtonTabIndex}
              dataHook="blogger-social-share-button"
            />
          </div>
        </div>
      </div>
    );
  }
}

export const ShareButtons = withTranslation()(withTrackFont(withBiLogger(ShareButtonsComponent)));
